import "./App.css";
import { Routes, Route, Link } from "react-router-dom";
import LoginPage from "./Component/loginpage/LoginPage";
import NineGridMenu from "./Component/NineMenu/NineGridMenu";
import Pos from "./Component/NineMenu/Screens/Pos";
import AllTables from "./Component/NineMenu/Screens/OrderPage/AllTables/AllTables";
import FirstLayout from "./Component/Layout/FirstLayout/FirstLayout";
import OrderLayout from "./Component/Layout/FirstLayout/OrderLayout";
import TakeAway from "./Component/NineMenu/Screens/OrderPage/TakeAway";
import Waiters from "./Component/NineMenu/Screens/OrderPage/Waiters";
import CustomerSearch from "./Component/NineMenu/Screens/OrderPage/CustomerSearch/CustomerSearch";
import OrderInnerLayout from "./Component/Layout/OrderInnerLayout/OrderInnerLayout";
import Order from "./Component/NineMenu/Screens/OrderInner/Order";
import Kitchen from "./Component/NineMenu/Screens/Kitchen/Kitchen";
import ProductLayout from "./Component/Layout/ProductLayout/ProductLayout";
import ProductsList from "./Component/NineMenu/Screens/Products/ProductsList";
import MenuList from "./Component/NineMenu/Screens/Products/MenuList";
import AddProductFormik from "./Component/NineMenu/Screens/Products/AddProduct/AddProductFormik";
import AddMenuFormik from "./Component/NineMenu/Screens/Products/AddMenu/AddMenuFormik";
import EditProductFormik from "./Component/NineMenu/Screens/Products/EditProduct/EditProductFormik";
import EditMenuFormik from "./Component/NineMenu/Screens/Products/EditMenu/EditMenuFormik";
import WarehouseList from "./Component/NineMenu/Screens/Warehouse/WarehouseList";
import WarehouseTypeList from "./Component/NineMenu/Screens/Warehouse/WarehouseTypeList";
import AddWarehouseTypeFormik from "./Component/NineMenu/Screens/Warehouse/AddWarehouseType/AddWarehouseTypeFormik";
import WorkPeriod from "./Component/NineMenu/Screens/WorkPeriod/WorkPeriod";
import Tickets from "./Component/NineMenu/Screens/Tickets/Tickets";
import ReportLayout from "./Component/Layout/ReportLayout/ReportLayout";
import WorkPeriodReport from "./Component/NineMenu/Screens/Report/WorkPeriodReport";
import SimpleLayout from "./Component/Layout/SimpleLayout";
import Dashboard from "./Component/NineMenu/Screens/AdminManage/Dashboard/Dashboard";
import EditWarehouseTypeFormik from "./Component/NineMenu/Screens/Warehouse/EditWarehouseType/EditWarehouseTypeFormik";
import AddWarehouseFormik from "./Component/NineMenu/Screens/Warehouse/AddWarehouse/AddWarehouseFormik";
import EditWarehouseFormik from "./Component/NineMenu/Screens/Warehouse/EditWarehouse/EditWarehouseFormik";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/nine-menu" element={<NineGridMenu />} />
        {/* <Route path="/pos" element={<Pos />} /> */}
        <Route
          path="/pos"
          element={
            <FirstLayout>
              <Pos />
            </FirstLayout>
          }
        />
        <Route
          path="/all-tables"
          element={
            <FirstLayout>
              <OrderLayout>
                <AllTables />
              </OrderLayout>
            </FirstLayout>
          }
        />
        <Route
          path="/take-away"
          element={
            <FirstLayout>
              <OrderLayout>
                <TakeAway />
              </OrderLayout>
            </FirstLayout>
          }
        />
        <Route
          path="/waiters"
          element={
            <FirstLayout>
              <OrderLayout>
                <Waiters />
              </OrderLayout>
            </FirstLayout>
          }
        />
        <Route
          path="/customer-search"
          element={
            <FirstLayout>
              <OrderLayout>
                <CustomerSearch />
              </OrderLayout>
            </FirstLayout>
          }
        />

        <Route
          path="/order-page"
          element={
            <OrderInnerLayout>
              <Order />
            </OrderInnerLayout>
          }
        />

        <Route
          path="/kitchen"
          element={
            <FirstLayout>
              <Kitchen />
            </FirstLayout>
          }
        />

        <Route
          path="/work-periods"
          element={
            <FirstLayout>
              <WorkPeriod />
            </FirstLayout>
          }
        />

        <Route
          path="/tickets"
          element={
            <FirstLayout>
              <Tickets />
            </FirstLayout>
          }
        />

        <Route
          path="/product-list"
          element={
            <ProductLayout>
              <ProductsList />
            </ProductLayout>
          }
        />

        <Route
          path="/menu-list"
          element={
            <ProductLayout>
              <MenuList />
            </ProductLayout>
          }
        />

        <Route
          path="/add-product"
          element={
            <ProductLayout>
              <AddProductFormik />
            </ProductLayout>
          }
        />

        <Route
          path="/edit-product"
          element={
            <ProductLayout>
              <EditProductFormik />
            </ProductLayout>
          }
        />

        <Route
          path="/add-menu"
          element={
            <ProductLayout>
              <AddMenuFormik />
            </ProductLayout>
          }
        />

        <Route
          path="/edit-menu"
          element={
            <ProductLayout>
              <EditMenuFormik />
            </ProductLayout>
          }
        />

        <Route
          path="/warehouse-list"
          element={
            <ProductLayout>
              <WarehouseList />
            </ProductLayout>
          }
        />

        <Route
          path="/add-warehouse"
          element={
            <ProductLayout>
              <AddWarehouseFormik />
            </ProductLayout>
          }
        />

        <Route
          path="/edit-warehouse"
          element={
            <ProductLayout>
              <EditWarehouseFormik />
            </ProductLayout>
          }
        />

        <Route
          path="/warehouse-type"
          element={
            <ProductLayout>
              <WarehouseTypeList />
            </ProductLayout>
          }
        />

        <Route
          path="/add-warehouse-type"
          element={
            <ProductLayout>
              <AddWarehouseTypeFormik />
            </ProductLayout>
          }
        />

        <Route
          path="/edit-warehouse-type"
          element={
            <ProductLayout>
              <EditWarehouseTypeFormik />
            </ProductLayout>
          }
        />

        <Route
          path="/work-period-report"
          element={
            <ReportLayout>
              <WorkPeriodReport />
            </ReportLayout>
          }
        />

        <Route
          path="/dashboard"
          element={
            <SimpleLayout>
              <Dashboard />
            </SimpleLayout>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
